import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Dormí 7 horas seguidas por primera vez en dos años. Me desperté y lloré de alegría.',
    author: 'Guadalupe, 52 años, Monterrey'
  }, {
    quote: 'El té me pareció tonto al principio. Pero a los 3 días ya no me despertaba pensando en el dinero.',
    author: 'Carmen, 49 años, Ciudad de México'
  }, {
    quote: 'Lo que más me gustó es que no me pide dos horas de meditación. Son pasos concretos. Los hice en 12 minutos. Y funcionaron.',
    author: 'Patricia V., 49 años, CDMX'
  }, {
    quote: 'Llevaba 3 años durmiendo mal. Esta guía fue lo primero que realmente hizo diferencia.',
    author: 'Carmen L., 57 años, Monterrey'
  }];
  return <section className="py-20 px-4 md:px-8 bg-navy-900 text-cream-100" data-id="element-282">
      <div className="max-w-6xl mx-auto" data-id="element-283">
        <div className="text-center mb-16" data-id="element-284">
          <span className="text-4xl mb-4 block" data-id="element-285">💬</span>
          <h2 className="text-gold-500 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-286">
            SECCIÓN 5 — PRUEBA SOCIAL
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-287">
            "Mujeres Como Tú Ya Duermen Diferente"
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-288">
          {testimonials.map((t, i) => <div key={i} className="bg-navy-800 p-8 rounded-xl border border-navy-700 relative hover:border-gold-500/50 transition-colors" data-id="element-289">
              <div className="flex gap-1 mb-4" data-id="element-290">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-5 w-5 text-gold-500 fill-current" data-id="element-291" />)}
              </div>
              <p className="text-xl font-serif italic text-cream-100 mb-6 leading-relaxed" data-id="element-292">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-293">
                <div className="h-10 w-10 rounded-full bg-gold-500 flex items-center justify-center text-navy-900 font-bold" data-id="element-294">
                  {t.author.charAt(0)}
                </div>
                <p className="font-bold text-gold-400 text-sm" data-id="element-295">{t.author}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}